import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop } from 'rxjs';
import { LsnErrorStateMatcher } from '../error-state-matcher';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputMaskComponent),
    multi: true
};

@Component({
    selector: 'app-input-mask',
    templateUrl: './input-mask.component.html',
    styleUrls: ['./input-mask.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class InputMaskComponent implements ControlValueAccessor {

    @Input() required = false;
    @Input() floatLabel: string;
    @Input() errorStateMatcher: LsnErrorStateMatcher;
    @Input() label: string;
    @Input() placeholder: string;
    @Input() suffix: string;
    @Input() disabled = false;
    @Input() autocomplete = 'off';
    @Input() name = '';
    @Input() type = 'text';
    @Input() suffixIconClass: string;
    @Input() textMask: any = {};

    @Output() onBlur = new EventEmitter();

    value: number = null;

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    constructor() {
    }


    onBlurAction() {
        this.onBlur.emit();
    }

    writeValue(value: any) {
        this.value = value;
        this.onChangeCallback(value);
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    blur($event: FocusEvent) {
        if (this.onBlur) {
            this.onBlur.emit($event);
        }
    }
}
